<template>
  <div>
    <h1 class="subpage-heading m-b-50">
      {{ t('lan_tab') }}
    </h1>

    <v-row class="m-b-70 loan-cards" justify="space-between">
      <v-col cols="12" md="4">
        <LoanRights is-frontpage />
      </v-col>

      <!-- Link Card -->
      <v-col cols="12" md="8">
        <LinkBox
          title="Umsóknir"
          :links="translatedLinks"
        />
      </v-col>
    </v-row>

    <!-- Tabs -->
    <v-tabs v-model="activeTab" bg-color="transparent">
      <v-tab :value="0">{{ t('lanaundirsida_tab1') }}</v-tab>
      <v-tab :value="1">{{ t('lanaundirsida_tab3') }}</v-tab>
    </v-tabs>

    <v-window v-model="activeTab" class="mt-4">
      <v-window-item :value="0">
        <div class="tabspace">
          <IFrameLanaYfirlit />
        </div>
      </v-window-item>

      <v-window-item :value="1">
        <div class="tabspace">
          <IframeLanaUmsokn />
        </div>
      </v-window-item>
    </v-window>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'

import LoanRights from '@/components/loanrights/LoanRights.vue'
import IFrameLanaYfirlit from '@/components/iframes/IframeLanaYfirlit.vue'
import IframeLanaUmsokn from '@/components/iframes/IframeLanaUmsokn.vue'
import LinkBox from '@/components/shared/LinkBox.vue'

const { t } = useI18n()

const activeTab = ref(0)

const translatedLinks = computed(() => [
  { title: t('lanaundirsida_link'), url: '/umsoknir/lan/lanaumsokn' },
  { title: t('umsoknir_eydublod_beidniumnafnabreytingu_texti'), url: '/umsoknir/lan/lan-nafnabreyting' },
  { title: t('umsoknir_eydublod_greidslufrestur_hlekkur_texti'), url: '/umsoknir/lan/lan-greidslufrest' },
  { title: t('umsoknir_eydublod_beidniumvedfluttning_texti'), url: '/umsoknir/lan/lan-vedflutning' },
])
</script>

<style scoped lang="scss">
@use '@/scss/settings/variables' as *;
@use '@/scss/settings/media-queries' as mq;

.loan-cards {
  @include mq.mobile {
    flex-direction: column;
    
    .v-col {
      max-width: 100%;
      flex-basis: 100%;
    }
  }
}

.link-container {
  margin-top: $spacing-md;
  max-width: 820px;
}
.link-box {
  padding: $card-padding;
  border-radius: $border-radius-lg;
  background-color: var(--v-theme-surface);
  border: 1px solid #EAEDEF;
  display: flex;
  flex-direction: column;
  gap: $spacing-md;

  h2 {
    font-size: $font-size-lg;
    font-weight: $font-weight-bold;
    color: $color-text;
    margin-bottom: 0;
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    gap: $gap-md;
    padding-left: 0;

    li {
      list-style: none;

      a {
        color: $color-text;
        font-weight: $font-weight-medium;
        text-decoration: none;
        padding-left: 20px;
        position: relative;
        transition: color 0.2s;


        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 16px;
          height: 16px;
          background-size: contain;
          background-repeat: no-repeat;
          // background-image: url('@/assets/new-icons/linkArrow.svg'); // optional
        }
      }
    }
  }
}

@media (max-width: 900px) {
  .link-container {
    min-width: 100%;
  }

  .link-box ul {
    display: block;

    li:not(:last-child) {
      margin-bottom: $spacing-sm;
    }
  }
}
</style>
